import { makeStyles } from "@material-ui/core/styles";
export const useStyles = makeStyles(theme => ({
    root: {
        boxShadow: '0px 3px 6px #00000029',
        background: '#fff',
        borderRadius: 4,
        "& button": {
            margin: '3px 1px',
        },
        "& svg": {
            fontSize: 18,
        },
        "& .MuiCircularProgress-root": {
            width: '14px !important',
            height: '14px !important',
            margin: 8,
        },
    },
    likeIcon: {
        color: '#F3994E',
        transition: 'transform .2s ease-in-out',
        "&:hover": {
            transform: 'rotate(-15deg)',
        }
    },
    loveIcon: {
        color: '#E1426E',
        transition: 'all .2s',
        transformOrigin: '50% 50%',
        "&:hover": {
            transform: 'scale(1.2)',
        }
    },
    replyIcon: {
        color: '#07519C',
    },
    displayReaction: {
        width: 36,
        fontSize: 13,
        "& svg": {
            fontSize: 18,
            transition: 'none',
            marginRight: 4,
            "&:hover": {
                transform: 'none',
            },
        },
    }
}));
